<template>
  <div>
    <vue2Dropzone
      id="vueDropzone"
      ref="vueDropzone"
      :options="dropzoneOptions"
      :destroy-dropzone="false"
      :awss3="awss3"
      @vdropzone-sending="sending"
      @vdropzone-error="error"
      @vdropzone-removed-file="remove"
      @vdropzone-queue-complete="queueCompleted"
      @vdropzone-s3-upload-error="s3UploadError"
      @vdropzone-s3-upload-success="s3UploadSuccess"
    />
    <v-btn
      class="mt-2"
      @click="startUpload"
    >
      {{ $t('Upload') }}
    </v-btn>
    <v-btn
      class="mt-2 ml-2"
      color="error"
      @click="removeAllFiles"
    >
      {{ $t('Remove') }}
    </v-btn>
  </div>
</template>
<script>
  // Other
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import store from '@/store/index'
  import Swal from 'sweetalert2'
  // MSAL
  import { loginRequest } from '@/config/msal'
  import { useMsal } from '@/msal/useMsal'
  const { instance } = useMsal()

  export default {
    name: 'ClientComponent',
    components: {
      vue2Dropzone,
    },
    props: {
      filesTransfertInfo: Object,
    },
    data () {
      return {
        folderDate: null,
        dropzoneOptions: {
          url: null,
          method: 'PUT',
          thumbnailWidth: 150,
          // maxFilesize: 100,
          // maxFiles: 2,
          acceptedFiles: '.pdf',
          addRemoveLinks: true, // Permet de supprimer un fichier
          autoProcessQueue: false, // Si true, upload le fichier immédiatement. Si false, doit appuyer sur un bouton pour uploader tous les fichiers
          dictDefaultMessage: `<i class="fas fa-file-import mr-2"></i>${this.$i18n.t('vueDropZone.dictDefaultMessage')}`,
          dictFallbackMessage: this.$i18n.t('vueDropZone.dictFallbackMessage'),
          dictFallbackText: this.$i18n.t('vueDropZone.dictFallbackText'),
          dictFileTooBig: `${this.$i18n.t('vueDropZone.dictFileTooBig')} ({{filesize}}MiB). ${this.$i18n.t('vueDropZone.dictFileTooBig1')} {{maxFilesize}}${this.$i18n.t('vueDropZone.dictFileTooBig2')}`,
          dictInvalidFileType: this.$i18n.t('vueDropZone.dictInvalidFileType'),
          dictResponseError: `${this.$i18n.t('vueDropZone.dictResponseError')} {{statusCode}}.`,
          dictCancelUpload: this.$i18n.t('vueDropZone.dictCancelUpload'),
          dictCancelUploadConfirmation: this.$i18n.t('vueDropZone.dictCancelUploadConfirmation'),
          dictRemoveFile: this.$i18n.t('Delete'),
          dictMaxFilesExceeded: this.$i18n.t('vueDropZone.dictMaxFilesExceeded'),
        },
        awss3: {
          signingURL: null,
          headers: {
            Authorization: null,
            'Content-Language': localStorage.getItem('APP_LANG_KEY'),
          },
          paramName: 'files', // Même nom que dans Multer
          sendFileToServer: false,
          withCredentials: false,
        },
      }
    },

    computed: {
    },

    async created () {
      // On envoie un paramètre supplémentaire dans le headers
      this.dropzoneOptions.url = `${process.env.VUE_APP_SERVER_ADDRESS}/01cell/aws-s3/addObjectBySignedUrl?bucket=${this.filesTransfertInfo.bucket}&key=${this.filesTransfertInfo.key}&fileName=${this.filesTransfertInfo.fileName}`
      this.awss3.signingURL = `${process.env.VUE_APP_SERVER_ADDRESS}/01cell/aws-s3/addObjectBySignedUrl?bucket=${this.filesTransfertInfo.bucket}&key=${this.filesTransfertInfo.key}&fileName=${this.filesTransfertInfo.fileName}`
      if (process.env.VUE_APP_AUTHENTIFICATION === 'oidc') {
        this.awss3.headers.Authorization = `Bearer ${store.state.oidcStore.access_token}`
      } else if (process.env.VUE_APP_AUTHENTIFICATION === 'msal') {
        try {
          const accounts = instance.getAllAccounts()
          const token = await instance.acquireTokenSilent({
            scopes: loginRequest.scopes,
            accounts,
          })
          this.awss3.headers.Authorization = `Bearer ${token.accessToken}`
        } catch (error) {
          console.log(error)
        }
      }
    },

    methods: {
      async startUpload () {
        try {
          // Start Spinner
          this.$loading.show()
          // On commence le upload
          this.$refs.vueDropzone.processQueue()
        } catch (error) {
          console.log(error)
        }
      },
      // Important car il faut envoyer les fichiers vers S3 en 'binary' par en 'form-data'
      sending (file, xhr, formData) {
        setTimeout(() => {
          // Aprés le transfert si la fenêtre pour la 'Gestion de la facturation' est ouverte, on va chercher les informations pour la facturation
          this.$emit('update-factures')
        }, 4000)
        const _send = xhr.send
        xhr.send = function () {
          _send.call(xhr, file)
        }
      },
      queueCompleted () {
        // this.$emit('update-factures')
        // Stop Spinner
        this.$loading.hide()
      },
      removeAllFiles () {
        this.$refs.vueDropzone.removeAllFiles()
      },
      error (file, error, xhr) {
        // Stop Spinner
        this.$loading.hide()
        console.log(file)
        console.log(error)
        console.log(xhr)
        Swal.fire(
          this.$i18n.t('error'),
          this.$i18n.t('tools.swal.text.The_file_cannot_be_uploaded'),
          'error',
        )
      },
      async remove (file) {
        console.log('remove')
        // if (file.id) {
        //   // Start Spinner
        //   this.$loading.show()
        //   try {
        //     // On peux supprimer la pièce jointe
        //     // Important. Il y a un hook dans le model pour supprimer le fichier
        //     // await SigitCablageCodeAttachmentService.remove(file.id)
        //     // Stop Spinner
        //     this.$loading.hide()
        //   } catch (error) {
        //     console.log(error)
        //     // Stop Spinner
        //     this.$loading.hide()
        //   }
        // }
      },
      s3UploadError (errorMessage) {
        // Stop Spinner
        this.$loading.hide()
        console.log(errorMessage)
      },
      s3UploadSuccess (s3ObjectLocation) {
        this.$emit('update-factures')
      },
    },
  }
</script>
